// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IyOY","title":"styles_title__1o--y"};